import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const HomeDelivery = styled.div`
  display: flex;
  align-items: center;
  margin-left: -${layout.measurements.spacing025};
  gap: ${layout.measurements.spacing025};
`;
